import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { animateScroll as scroll, scroller } from 'react-scroll';

function Menu() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleJuryClick = (event) => {
    event.preventDefault(); // Предотвращает стандартное поведение кнопки

    if (location.pathname === '/') {
      scroller.scrollTo('jury-section', {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
      });
    } else {
      navigate('/');
      setTimeout(() => {
        scroller.scrollTo('jury-section', {
          duration: 800,
          delay: 0,
          smooth: 'easeInOutQuart',
        });
      }, 500);
    }
  };

  return (
    <div className="menu">
      <div className="container">
        <div className="menu-links">
          <Link to="/">Главная</Link>
          <Link to="/history">История конкурса</Link>
          <Link to="/nominations">Номинации</Link>
          <Link to="/regulations">ПОЛОЖЕНИЕ</Link>
          <Link to="/" onClick={handleJuryClick}>ЖЮРИ</Link>
          <Link to="/gallery">Галерея</Link>
          <Link to="/contacts">КОНТАКТЫ</Link>
        </div>
        <div className="menu-contact">
          <a className="menu-tel" href="tel:+7 495 225 76 86">
            +7 495 225 76 86
          </a>
          <a href="mailto:design_2001@gmail.ru">design_2001@gmail.ru</a>
        </div>
      </div>
    </div>
  );
}

export default Menu;
